const pino = require('pino')

const levels = ['silent', 'trace', 'debug', 'info', 'warn', 'error', 'fatal']

function logger (name) {
  name = name || ''
  const log = pino({
    name,
    level: levels.includes(process.env.LOG_LEVEL) ? process.env.LOG_LEVEL : 'info'
  })
  return log
}

module.exports = logger
